/* import __COLOCATED_TEMPLATE__ from './impact-cell.hbs'; */
/* RESPONSIBLE TEAM: team-conversational-knowledge */

import Component from '@glimmer/component';
import type ContentWrapper from 'embercom/models/content-service/content-wrapper';

interface Args {
  contentWrapper: ContentWrapper;
}

export default class ImpactCell extends Component<Args> {
  get impact() {
    return (
      this.args.contentWrapper.contentReviewSuggestionMetadata?.included_conversations?.length ||
      undefined
    );
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'ContentService::AiContentLibrary::List::Cells::ImpactCell': typeof ImpactCell;
  }
}
